import React, { useEffect, useState } from "react";
import Base from "components/Creation/components/Base";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import Select from "react-select";
import useSelection from "hooks/useSelection";

import "./index.css";
const When = () => {
  const [when, setWhen] = useState({
    date: moment().add(24, "hours").toDate(),
    startTime: "19:00",
    endTime: "22:00",
  });
  const { setSelectionForKey, redirectIfNotValidUpUntilKey } = useSelection({
    key: "when",
    setter: setWhen,
  });

  const [msg, setMsg] = useState(null);

  const [startTimeOptions, setStartTimeOptions] = useState([]);
  const [endTimeOptions, setEndTimeOptions] = useState([]);

  let timeOptions = [];

  //Set timeoptions for every time available in 30min incrememnts
  for (let i = 0; i < 48; i++) {
    let time = moment()
      .startOf("day")
      .add(i * 30, "minutes");
    timeOptions.push({
      value: time.format("HH:mm"),
      label: time.format("HH:mm"),
    });
  }

  useEffect(() => {
    redirectIfNotValidUpUntilKey("when");
  }, []);

  useEffect(() => {
    //Set start time options
    let startDateTime = moment(when.date);
    startDateTime.set({
      hour: when.startTime.split(":")[0],
      minute: when.startTime.split(":")[1],
    });
    setStartTimeOptions(
      timeOptions.filter((time) => {
        let checkTime = startDateTime.clone().set({
          hour: time.value.split(":")[0],
          minute: time.value.split(":")[1],
        });
        return checkTime.isAfter(moment().add(24, "hours"));
      })
    );

    //Set end time options to be max 5 hours after start time
    let maxEndTime = startDateTime.clone().add(5.5, "hours");

    let currentEndTimeOption = startDateTime.add(30, "minutes");

    let endTimeOptionsToBe = [];
    while (currentEndTimeOption.isBefore(maxEndTime)) {
      endTimeOptionsToBe.push({
        value: currentEndTimeOption.format("HH:mm"),
        label: currentEndTimeOption.format("HH:mm"),
      });
      currentEndTimeOption.add(30, "minutes");
    }

    endTimeOptionsToBe.shift();

    setEndTimeOptions(endTimeOptionsToBe);

    // setEndTimeOptions(
    //   timeOptions.filter((time) => {
    //     let checkTime = startDateTime.clone().set({
    //       hour: time.value.split(":")[0],
    //       minute: time.value.split(":")[1],
    //     });

    //     if (checkTime.format("HH").indexOf("0") === 0) {
    //       checkTime.add(1, "day");
    //     }

    //     let isValid = checkTime.isBefore(maxEndTime);
    //     console.log(
    //       "time option",
    //       moment(checkTime).format("DD/MM/YYYY HH:mm"),
    //       "max time",
    //       moment(maxEndTime).format("DD/MM/YYYY HH:mm"),
    //       "isBefore",
    //       isValid
    //     );
    //     return isValid;
    //   })
    // );

    if (moment(when.startTime, "HH:mm") > moment(when.endTime, "HH:mm")) {
      setMsg(
        <>
          the length of time and type of activity selected may impact the budget
          requested
          <br />
          <strong>note:</strong>&nbsp;your end time finishes on the following
          day
        </>
      );
    } else {
      // setMsg(null);
      setMsg(
        <>
          the length of time and type of activity selected may impact the budget
          requested
        </>
      );
    }
  }, [when.date, when.startTime, when.endTime]);

  //Ensure start time is an available from available options
  useEffect(() => {
    if (startTimeOptions.length === 0) return;
    if (!startTimeOptions.find((option) => option.value === when.startTime)) {
      setSelectionForKey({
        ...when,
        startTime: startTimeOptions[0].value,
      });
    }
  }, [startTimeOptions]);

  //Ensure end time is an available from available options
  useEffect(() => {
    if (endTimeOptions.length === 0) return;
    if (!endTimeOptions.find((option) => option.value === when.endTime)) {
      setSelectionForKey({
        ...when,
        endTime: endTimeOptions[endTimeOptions.length - 1].value,
      });
    }
  }, [endTimeOptions]);

  const selectStyle = {
    borderRadius: "50px",
    borderColor: "rgba(0,0,0,0.1)",
    boxShadow: "0px 0px 20px rgba(0,0,0,0.2)",
  };

  return (
    <Base
      title="When?"
      infoBody="select when you’d like us to book your surprise date. you have a choice of duration ranging from 1 to 5hrs."
    >
      <div className="container mx-auto flex items-center grow flex-col justify-center z-10 mt-4">
        {/* <p>Selected: </p>
        <ul className="inline">
          <li>Date: {moment(when.date).format("ddd DD/MM/YYYY")}</li>
          <li>Start Time: {when.startTime}</li>
          <li>End Time: {when.endTime}</li>
        </ul>
        <br /> */}
        <div className="md:mx-auto">
          <div
            className="p-4 md:p-8 "
            style={{
              backgroundImage: "url(/images/when/calendar-bg.png)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: "10px",
              border: "1px solid white",
              fontSize: "13px",
            }}
          >
            <Calendar
              style={{
                border: 0,
                background: "none",
              }}
              onChange={(date) => {
                setSelectionForKey({
                  ...when,
                  date: date,
                });
              }}
              value={moment(when.date).toDate()}
              minDate={moment().add(24, "hours").toDate()}
            />
          </div>

          <div className="mt-4 flex items-end text-center gap-4 mx-auto">
            <div className="grow flex-col">
              <h4 className="mb-2">Start Time</h4>
              <select
                value={when.startTime}
                onChange={(value) => {
                  setSelectionForKey({
                    ...when,
                    startTime: value.target.value,
                  });
                }}
                style={selectStyle}
              >
                {startTimeOptions.map((timeOption) => {
                  return <option>{timeOption.label}</option>;
                })}
              </select>
            </div>
            <div className="pb-2">-</div>
            <div className="grow flex-col">
              <h4 className="mb-2">End Time</h4>
              <select
                value={when.endTime}
                onChange={(value) => {
                  setSelectionForKey({
                    ...when,
                    endTime: value.target.value,
                  });
                }}
                style={selectStyle}
              >
                {endTimeOptions.map((timeOption) => {
                  return <option>{timeOption.label}</option>;
                })}
              </select>
            </div>
          </div>
        </div>
        <div className="container mx-auto p-4 text-center">
          {msg && <p>{msg}</p>}
        </div>
      </div>
    </Base>
  );
};

export default When;
